import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpIconComponent } from './icon.component';
import {
  ChevronLeftIconComponent,
  ChevronRightIconComponent,
  ClockIconComponent,
  HomeIconComponent,
  InfoIconComponent,
  OpAlarmIconComponent,
  OpAlarmSetIconComponent,
  OpCursorRectangleSelectIconComponent,
  OpCursorSelectIconComponent,
  OpEnterpriseAddonsIconComponent,
  OpEraseIconComponent,
  OpFirstPersonViewIconComponent,
  OpGridMenuIconComponent,
  OpGroupIconComponent,
  OpHierarchyIconComponent,
  OpNoHierarchyIconComponent,
  OpOrthographicPerspectiveIconComponent,
  OpResizerVerticalLinesIconComponent,
  OpScissorsIconComponent,
  OpThreedReturnDefaultIconComponent,
  OpViewFitToIconComponent,
  OpViewModalIconComponent,
  OpViewThreedIconComponent,
  PackageIconComponent,
  PersonIconComponent,
  QuestionIconComponent,
  ScreenFullIconComponent,
  ShareAndroidIconComponent,
  StarFillIconComponent,
  StarIconComponent,
  XIconComponent,
  OpGitlabIssueClosedIconComponent,
  OpGitlabLabelsIconComponent,
  OpGitlabIssueOpenIconComponent,
  OpGitlabMergeRequestClosedIconComponent,
  OpGitlabMergeRequestMergedIconComponent,
  OpGitlabMergeRequestOpenIconComponent,
  OpGitlabMergeRequestReadyIconComponent,
  OpGitlabPipelineStatusCanceledIconComponent,
  OpGitlabPipelineStatusCreatedIconComponent,
  OpGitlabPipelineStatusFailedIconComponent,
  OpGitlabPipelineStatusManualIconComponent,
  OpGitlabPipelineStatusPendingIconComponent,
  OpGitlabPipelineStatusPreparingIconComponent,
  OpGitlabPipelineStatusRunningIconComponent,
  OpGitlabPipelineStatusScheduledIconComponent,
  OpGitlabPipelineStatusSkippedIconComponent,
  OpGitlabPipelineStatusSuccessIconComponent,
  OpGitlabPipelineStatusWaitingIconComponent,
  XCircleIconComponent,
  KebabHorizontalIconComponent,
  ReadIconComponent,
  EyeIconComponent,
  EyeClosedIconComponent,
  ArrowLeftIconComponent,
  GrabberIconComponent,
  PlusIconComponent,
  OpFileCsvIconComponent,
  OpFileDocIconComponent,
  OpFileSheetIconComponent,
  OpFileTextIconComponent,
  OpFilePresentationIconComponent,
  OpPdfIconComponent,
  CloudIconComponent,
  DownloadIconComponent,
  FileDirectoryFillIconComponent,
  FileDirectoryOpenFillIconComponent,
  ServerIconComponent,
  FileIconComponent,
  FileMediaIconComponent,
  TasklistIconComponent,
  LinkIconComponent,
  LinkExternalIconComponent,
  UploadIconComponent,
  UnlinkIconComponent,
  OpMarkNextcloudIconComponent,
  AlertFillIconComponent,
  BugIconComponent,
  TrashIconComponent,
  PaperclipIconComponent,
  OpAddAttachmentIconComponent,
  TriangleRightIconComponent,
  OpStopwatchStopIconComponent,
  CopyIconComponent,
  TriangleDownIconComponent,
  OpArrowInIconComponent,
  ReplyIconComponent,
  OpTriangleDeltaIconComponent,
  OpBaselineIconComponent,
  SearchIconComponent,
  AlertIconComponent,
  ListUnorderedIconComponent,
  OpStopwatchStartIconComponent,
  ChevronDownIconComponent,
} from '@openproject/octicons-angular';
import { OpBaselineComponent } from 'core-app/features/work-packages/components/wp-baseline/baseline/baseline.component';

@NgModule({
  imports: [
    CommonModule,

    AlertIconComponent,
    AlertFillIconComponent,
    BugIconComponent,
    ChevronDownIconComponent,
    ChevronLeftIconComponent,
    ChevronRightIconComponent,
    ClockIconComponent,
    CloudIconComponent,
    CopyIconComponent,
    DownloadIconComponent,
    FileDirectoryFillIconComponent,
    FileDirectoryOpenFillIconComponent,
    FileIconComponent,
    FileMediaIconComponent,
    HomeIconComponent,
    InfoIconComponent,
    LinkIconComponent,
    LinkExternalIconComponent,
    ListUnorderedIconComponent,
    OpAddAttachmentIconComponent,
    OpAlarmIconComponent,
    OpAlarmSetIconComponent,
    OpArrowInIconComponent,
    OpBaselineIconComponent,
    OpCursorRectangleSelectIconComponent,
    OpCursorSelectIconComponent,
    OpEnterpriseAddonsIconComponent,
    OpEraseIconComponent,
    OpFileCsvIconComponent,
    OpFileDocIconComponent,
    OpFilePresentationIconComponent,
    OpFileSheetIconComponent,
    OpFileTextIconComponent,
    OpFirstPersonViewIconComponent,
    OpGridMenuIconComponent,
    OpGroupIconComponent,
    OpHierarchyIconComponent,
    OpNoHierarchyIconComponent,
    OpMarkNextcloudIconComponent,
    OpOrthographicPerspectiveIconComponent,
    OpPdfIconComponent,
    OpResizerVerticalLinesIconComponent,
    OpScissorsIconComponent,
    OpStopwatchStartIconComponent,
    OpStopwatchStopIconComponent,
    OpThreedReturnDefaultIconComponent,
    OpTriangleDeltaIconComponent,
    OpViewFitToIconComponent,
    OpViewModalIconComponent,
    OpViewThreedIconComponent,
    PackageIconComponent,
    PaperclipIconComponent,
    PersonIconComponent,
    QuestionIconComponent,
    ScreenFullIconComponent,
    SearchIconComponent,
    ServerIconComponent,
    ShareAndroidIconComponent,
    StarFillIconComponent,
    StarIconComponent,
    TasklistIconComponent,
    TrashIconComponent,
    TriangleRightIconComponent,
    UploadIconComponent,
    UnlinkIconComponent,
    XIconComponent,

    OpGitlabIssueClosedIconComponent,
    OpGitlabLabelsIconComponent,
    OpGitlabIssueOpenIconComponent,
    OpGitlabMergeRequestClosedIconComponent,
    OpGitlabMergeRequestMergedIconComponent,
    OpGitlabMergeRequestOpenIconComponent,
    OpGitlabMergeRequestReadyIconComponent,
    OpGitlabPipelineStatusCanceledIconComponent,
    OpGitlabPipelineStatusCreatedIconComponent,
    OpGitlabPipelineStatusFailedIconComponent,
    OpGitlabPipelineStatusManualIconComponent,
    OpGitlabPipelineStatusPendingIconComponent,
    OpGitlabPipelineStatusPreparingIconComponent,
    OpGitlabPipelineStatusRunningIconComponent,
    OpGitlabPipelineStatusScheduledIconComponent,
    OpGitlabPipelineStatusSkippedIconComponent,
    OpGitlabPipelineStatusSuccessIconComponent,
    OpGitlabPipelineStatusWaitingIconComponent,

    XCircleIconComponent,

    KebabHorizontalIconComponent,
    ReadIconComponent,
    EyeIconComponent,
    EyeClosedIconComponent,
    ArrowLeftIconComponent,
    GrabberIconComponent,
    PlusIconComponent,
    ReplyIconComponent,
    TriangleDownIconComponent,
  ],
  declarations: [
    OpIconComponent,
  ],
  providers: [],
  exports: [
    OpIconComponent,

    AlertIconComponent,
    AlertFillIconComponent,
    BugIconComponent,
    ChevronDownIconComponent,
    ChevronLeftIconComponent,
    ChevronRightIconComponent,
    ClockIconComponent,
    CloudIconComponent,
    CopyIconComponent,
    DownloadIconComponent,
    FileDirectoryFillIconComponent,
    FileDirectoryOpenFillIconComponent,
    FileIconComponent,
    FileMediaIconComponent,
    HomeIconComponent,
    InfoIconComponent,
    LinkIconComponent,
    LinkExternalIconComponent,
    ListUnorderedIconComponent,
    OpAddAttachmentIconComponent,
    OpAlarmIconComponent,
    OpAlarmSetIconComponent,
    OpArrowInIconComponent,
    OpBaselineIconComponent,
    OpCursorRectangleSelectIconComponent,
    OpCursorSelectIconComponent,
    OpEnterpriseAddonsIconComponent,
    OpEraseIconComponent,
    OpFileCsvIconComponent,
    OpFileDocIconComponent,
    OpFilePresentationIconComponent,
    OpFileSheetIconComponent,
    OpFileTextIconComponent,
    OpFirstPersonViewIconComponent,
    OpGridMenuIconComponent,
    OpGroupIconComponent,
    OpHierarchyIconComponent,
    OpNoHierarchyIconComponent,
    OpMarkNextcloudIconComponent,
    OpOrthographicPerspectiveIconComponent,
    OpPdfIconComponent,
    OpResizerVerticalLinesIconComponent,
    OpScissorsIconComponent,
    OpStopwatchStartIconComponent,
    OpStopwatchStopIconComponent,
    OpThreedReturnDefaultIconComponent,
    OpTriangleDeltaIconComponent,
    OpViewFitToIconComponent,
    OpViewModalIconComponent,
    OpViewThreedIconComponent,
    PackageIconComponent,
    PaperclipIconComponent,
    PersonIconComponent,
    QuestionIconComponent,
    ScreenFullIconComponent,
    SearchIconComponent,
    ServerIconComponent,
    ShareAndroidIconComponent,
    StarFillIconComponent,
    StarIconComponent,
    TasklistIconComponent,
    TrashIconComponent,
    TriangleRightIconComponent,
    UploadIconComponent,
    UnlinkIconComponent,
    XIconComponent,

    OpGitlabIssueOpenIconComponent,
    OpGitlabIssueClosedIconComponent,
    OpGitlabLabelsIconComponent,
    OpGitlabMergeRequestClosedIconComponent,
    OpGitlabMergeRequestMergedIconComponent,
    OpGitlabMergeRequestOpenIconComponent,
    OpGitlabMergeRequestReadyIconComponent,
    OpGitlabPipelineStatusCanceledIconComponent,
    OpGitlabPipelineStatusCreatedIconComponent,
    OpGitlabPipelineStatusFailedIconComponent,
    OpGitlabPipelineStatusManualIconComponent,
    OpGitlabPipelineStatusPendingIconComponent,
    OpGitlabPipelineStatusPreparingIconComponent,
    OpGitlabPipelineStatusRunningIconComponent,
    OpGitlabPipelineStatusScheduledIconComponent,
    OpGitlabPipelineStatusSkippedIconComponent,
    OpGitlabPipelineStatusSuccessIconComponent,
    OpGitlabPipelineStatusWaitingIconComponent,
    XCircleIconComponent,

    KebabHorizontalIconComponent,
    ReadIconComponent,
    EyeIconComponent,
    EyeClosedIconComponent,
    ArrowLeftIconComponent,
    GrabberIconComponent,
    PlusIconComponent,
    ReplyIconComponent,
    TriangleDownIconComponent,
  ],
})

export class IconModule {}
